// Labels every team profile shares, Italian: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Dati personali',
    rows: {
      name: 'Nome',
      position: 'Ruolo',
      birthdate: 'Data di nascita',
      nationality: 'Nazionalità',
      maritalStatus: 'Stato civile',
      location: 'Località',
      languages: 'Lingue',
      programmingLanguages: 'Linguaggi di programmazione',
      certifications: 'Certificazioni',
      publications: 'Pubblicazioni',
      links: 'Sito web'
    }
  },
  education: {
    title: 'Formazione'
  },
  skills: {
    title: 'Competenze specialistiche'
  },
  experience: {
    title: 'Progetti e attività',
    techLabel: 'Tecnologie'
  },
  downloads: {
    title: 'Scarica il profilo',
    deLabel: 'Scarica il profilo in tedesco',
    deDescription: 'PDF in tedesco',
    enLabel: 'Scarica il CV in inglese',
    enDescription: 'PDF in inglese'
  },
  cta: {
    title: 'Contatti',
    button: 'Mettiti in contatto'
  },
  pdf: {
    title: 'Profilo',
    personalSection: 'Dati personali',
    educationSection: 'Formazione',
    experienceSection: 'Progetti e attività',
    skillsLabel: 'Competenze'
  }
};
